export const getAppleMapsUrlForCoordinates = (coordinates, name) => {
  const url = new URL('https://maps.apple.com/?dirflg=w&z=16')
  url.searchParams.set('daddr', `${coordinates[1]},${coordinates[0]}`)
  if (name) {
    url.searchParams.set('q', name)
  }
  return url
}
